import { useState } from 'react';
import { getAuthenticatedClient } from '../Utils/tokenHelper';
import { useAccount, useMsal } from '@azure/msal-react';
import { enableFrontdoor } from '../Utils/features';

const BASE_URL = enableFrontdoor ? process.env.REACT_APP_PRICER_API_BASE_URL_FRONTDOOR : process.env.REACT_APP_PRICER_API_BASE_URL;

export default function useDeleteBatchApi() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0]);

    const execute = async (batchId) => {
        setError(undefined);
        setLoading(true);

        try {
            await (await getAuthenticatedClient({
                url: `${BASE_URL}/status/event`,
                method: 'POST',
                body: {
                    batchId,
                    eventType: 'Batch',
                    eventName: 'BatchDeleted',
                    eventDate: new Date().toISOString(),
                    source: 'MRPPortal'
                },
                msalInstance: instance,
                account
            }))
        } catch (e) {
            setError(e);
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        execute
    };
}